import React from "react";
var __jsx = React.createElement;
import TermsComponent from "components/ScreenComponent/TermsComponent";
import Head from "next/head";
export default function HuntTracker() {
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "WRewards - Terms Of Service")), __jsx(TermsComponent, null));
}